// apps/web/src/App.tsx
import { Routes, Route, Navigate } from 'react-router-dom';

// Layout
import Layout from './components/layout/Layout';

// Pages
import Home from './pages/Home';
import Events from './pages/Events';
import Immigration from './pages/Immigration';
import Guides from './pages/Guides';
import GuideDetail from './pages/Guides/GuideDetail';
import Financial from './pages/Financial';
import FinancialCaseStudies from './pages/Financial/CaseStudies';
import FinancialCaseStudyDetail from './pages/Financial/CaseStudyDetail';
import FinancialCalculators from './pages/Financial/Calculators';
import FinancialCalculatorDetail from './pages/Financial/CalculatorDetail';
import FinancialPlaybooks from './pages/Financial/Playbooks';
import FinancialMethodology from './pages/Financial/Methodology';
import FinancialDisclosures from './pages/Financial/Disclosures';
import CountryGuides from './pages/CountryGuides';
import CountryDetail from './pages/CountryGuides/CountryDetail';
import Help from './pages/Help';
import About from './pages/Static/About';
import Privacy from './pages/Static/Privacy';
import Terms from './pages/Static/Terms';
import Careers from './pages/Static/Careers';
import Press from './pages/Static/Press';
import Contact from './pages/Contact';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import VerifyEmail from './pages/Auth/VerifyEmail';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import CollectEmail from './pages/Auth/CollectEmail';
import Profile from './pages/Auth/Profile';
import Remittance from './pages/Remittance';
import MentorshipInbox from './pages/Mentorship/Inbox';
import BusinessDashboard from './pages/Business/Dashboard';
import BusinessSuccess from './pages/Business/Success';
import AdminLayout from './pages/Admin';
import AdminDashboard from './pages/Admin/Dashboard';
import AdminUsers from './pages/Admin/Users';
import AdminPosts from './pages/Admin/Posts';
import AdminEvents from './pages/Admin/Events';
import AdminPlaces from './pages/Admin/Places';
import AdminDeals from './pages/Admin/Deals';
import AdminClaims from './pages/Admin/Claims';
import AdminIntegrations from './pages/Admin/Integrations';

export default function App() {
  return (
    <Routes>
      {/* Auth routes - standalone pages without sidebar */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/collect-email" element={<CollectEmail />} />
      
      {/* Main routes with layout (sidebar, header, etc.) */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        {/*
          Retired in favour of the editorial hub. These mirror the 301s in
          public/_redirects: the _redirects rules catch cold loads and external
          links, these catch in-app navigation, which never touches the edge.
          `replace` keeps the dead URL out of history so Back does not bounce.

          /mentorship is matched exactly, so /mentorship/inbox below still
          resolves — it is a real authenticated route, not part of the pivot.
        */}
        <Route path="community" element={<Navigate to="/guides" replace />} />
        <Route
          path="mentorship"
          element={<Navigate to="/guides/finding-bilingual-mentors" replace />}
        />

        <Route path="events" element={<Events />} />
        <Route path="remittance" element={<Remittance />} />
        <Route path="mentorship/inbox" element={<MentorshipInbox />} />
        <Route path="business/dashboard" element={<BusinessDashboard />} />
        <Route path="business/success" element={<BusinessSuccess />} />
        <Route path="immigration" element={<Immigration />} />
        <Route path="guides" element={<Guides />} />
        <Route path="guides/:slug" element={<GuideDetail />} />

        {/*
          Financial section. Migrated from the standalone realiform.com build.
          `case-studies` and `calculators` are declared before their `:slug`
          children so the index route is never shadowed by the parameterised one.
        */}
        <Route path="financial" element={<Financial />} />
        <Route path="financial/case-studies" element={<FinancialCaseStudies />} />
        <Route path="financial/case-studies/:slug" element={<FinancialCaseStudyDetail />} />
        <Route path="financial/calculators" element={<FinancialCalculators />} />
        <Route path="financial/calculators/:slug" element={<FinancialCalculatorDetail />} />
        <Route path="financial/playbooks" element={<FinancialPlaybooks />} />
        <Route path="financial/methodology" element={<FinancialMethodology />} />
        <Route path="financial/disclosures" element={<FinancialDisclosures />} />
        <Route path="countries" element={<CountryGuides />} />
        <Route path="countries/:countryCode" element={<CountryDetail />} />
        <Route path="help" element={<Help />} />
        <Route path="about" element={<About />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="careers" element={<Careers />} />
        <Route path="press" element={<Press />} />
        <Route path="contact" element={<Contact />} />
        <Route path="profile" element={<Profile />} />

        {/* Admin routes with nested layout */}
        <Route path="admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="posts" element={<AdminPosts />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="claims" element={<AdminClaims />} />
          <Route path="integrations" element={<AdminIntegrations />} />
        </Route>
      </Route>
    </Routes>
  );
}
